import React from 'react'
import Header from './Header'
import Footer from './Footer'
import { PERSONAL_INFO_VIEW_TYPE, STEPS } from './useReservation'
import PersonalInfoView from './PersonalInfoView'
import ParticipantsView from './ParticipantsView'
import PaymentView from './PaymentView'
import { useReservationContext } from './ReservationContext'
import InsuranceView from './InsuranceView'
import Parkings from './Parkings'
import Loader from '../search-trip/components/Loader'

const Content = ({ terms }) => {
    const {
        stepReservationDescription,
        nextStep,
        offer,
        loading,
        reservationLoading,
        paymentMethod,
        handleSubmit,
        currentStep,
        personalInfoViewType,
        t
    } = useReservationContext()

    const StepComponents = {
        [STEPS.PERSONAL_INFO]: PersonalInfoView,
        [STEPS.PARTICIPANTS]: ParticipantsView,
        [STEPS.INSURANCE]: InsuranceView,
        [STEPS.PARKING]: Parkings,
        [STEPS.PAYMENT]: PaymentView,
    }

    const CurrentStepComponent = StepComponents[currentStep]

    if (!loading && (!offer || !offer.availibility || (offer.availibility && offer.availibility !== 'r'))) {
        return (
            <div className="trip-reservation__right">
                <div className="trip-reservation__non-availiable-offer">
                    <b>{t('offer-unavailable')}</b>
                    <span>{t('ask-about-availability')}.</span>
                    <a
                        href="tel:+48585858058"
                        title="Rezerwacja telefonicznie"
                        role="button"
                        type="button"
                        className={`trip-reservation__btn-contact`}
                    >
                        +48 58 58 58 058
                    </a>
                    <a
                        href="mailto:rezerwacja@vacationclub.pl"
                        title="Rezerwacja email"
                        role="button"
                        type="button"
                        className={`trip-reservation__btn-contact`}
                    >
                        rezerwacja@vacationclub.pl
                    </a>
                </div>
            </div>
        )
    }

    return (
        <div className="trip-reservation__right">
            {loading ? (
                <div className="trip-reservation__loading-container">
                    <Loader />
                </div>
            ) : (
                <>
                    <Header />
                    <hr className="trip-reservation__divider" />
                    <CurrentStepComponent terms={terms}/>
                    <hr className="trip-reservation__divider" />
                    {personalInfoViewType === PERSONAL_INFO_VIEW_TYPE.FORM && (
                        <Footer
                            headingText={t('all-set')}
                            subheaderText={stepReservationDescription}
                            onClick={currentStep === STEPS.PAYMENT ? handleSubmit : nextStep}
                            paymentMethod={paymentMethod}
                            reservationLoading={reservationLoading}
                            currentStep={currentStep}
                            offer={offer}
                        />
                    )}
                </>
            )}
        </div>
    )
}

export default Content
